import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import InnerBannerBreadcrumb from "../../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { convertStringToArray, extractDate } from "../../../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import PageLastUpdated from "../../../../components/shared/PageLastUpdated";
import Viewer from "react-viewer";
import { imageUrl } from "../../../../constants/constants";

function PhotoDetailById() {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { nid } = useParams();
  const { data: photosGalleryData = [], isLoading: photosGalleryIsLoading } =
    useGetProtectedApiDataQuery({ url: "photo_gallery", lang: languageType });

  const {
    data: photosGalleryArchiveData = [],
    isLoading: photosGalleryArchiveIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "photo_gallery_archive",
    lang: languageType,
  });

  const allPhotos = [...photosGalleryData, ...photosGalleryArchiveData];

  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const selectedPhoto = allPhotos.find((photo) => photo.nid === nid);

  console.log(selectedPhoto);

  const photoArray = convertStringToArray(
    selectedPhoto?.field_mulitple_photo_upload,
  );

  console.log(photoArray);

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };

  const lastUpdatedOn = useMemo(() => {
    return extractDate(selectedPhoto);
  }, [selectedPhoto]);

  if (photosGalleryIsLoading || photosGalleryArchiveIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Photo Gallery", "फोटो गैलरी")}
        titleLink="/photo-gallery-detail"
        titleTwo={
          selectedPhoto?.title || getText("Photo Not Found", "फोटो नहीं मिला")
        }
        levelTwo={true}
        levelThree={false}
        isActive={
          selectedPhoto?.title || getText("Photo Not Found", "फोटो नहीं मिला")
        }
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="row mb-5">
                {photoArray?.length === 0 ? (
                  <p>No photos available</p>
                ) : (
                  photoArray?.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3 photo-detail"
                    >
                      <div className="card-sec">
                        <div className="img-sec">
                          <a
                            style={{ cursor: "pointer" }}
                            className="masonry-item"
                            onClick={() => {
                              openViewer(photoArray, index);
                            }}
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${item?.file_path}`}
                              alt={item.title}
                              width={100}
                            />
                            {item.title && (
                              <div className="desc-sec">
                                <p className="gallery-line-clamp">
                                  {item.title}
                                </p>
                              </div>
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
}

export default PhotoDetailById;
